export const contentTableConfig = {
  title: '回复列表',
  propList: [
    {prop: 'uname', label: '客户昵称', minWidth: '120', slotName: 'consumer', align: 'left'},
    {prop: 'unionid', label: 'UnionID', minWidth: '80', align: 'left'},
    {prop: 'createdAt', label: '添加时间', minWidth: '100', sortable: 'custom'},
    {prop: 'lastMsgTime', label: '最后回复时间', minWidth: '100', sortable: 'custom'},
    {prop: 'lastReply', label: '最后回复内容', minWidth: '80', align: 'left'},
    {prop: 'corpName', label: '主体名称', minWidth: '80', align: 'left'},
    {prop: 'sid', label: '账号ID', minWidth: '80', align: 'left'},
    {prop: 'sname', label: '账号名称', minWidth: '80', align: 'left'},
    {prop: 'usedBy', label: '使用人', minWidth: '60', align: 'left'},
    {prop: 'deptName', label: '所属部门', minWidth: '60', align: 'left'},
    {prop: 'parentDeptName', label: '所属组', minWidth: '70', align: 'left'}
  ],
  showIndexColumn: false,
  showSelectColumn: true
}
